export default __webpack_public_path__ + "static/media/frog_R1_C6.4c1f1a82.png";